import React, { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  // onSnapshot,
} from "firebase/firestore";
import "../styles/user.css";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable"; // ✅ This is required to add the plugin
import { updateDoc, doc, deleteDoc } from "firebase/firestore";

console.log(typeof jsPDF.prototype.autoTable); // should log 'function'

const Securitydash = () => {
  const [hid, sethid] = useState("");
  const [name, setName] = useState("");
  const [employeeData, setEmployeeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [leaveReason, setLeaveReason] = useState("");
  const [leaveStatus, setLeaveStatus] = useState(null);
  const [userName, setUserName] = useState(""); // user's personal name
  // const [countdown, setCountdown] = useState(300); // 5 minutes in seconds
  const navigate = useNavigate();
  // const [validPNo, setValidPNo] = useState("");
  // const [leaveType, setLeaveType] = useState("Annual"); // default option
  
  const [leaveHistory, setLeaveHistory] = useState([]);
  // const [selectedDates, setSelectedDates] = useState([]);
  // const [leaveDates, setLeaveDates] = useState([]); // { date: string, leaveType: string, status: 'Pending' }
  // const [searchValue, setSearchValue] = useState("");
    
  const exportPDF = () => { 
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("Leave History Report", 14, 20);

    if (employeeData) {
      doc.setFontSize(12);
      doc.text(`Name: ${employeeData.name}`, 14, 30);
      doc.text(`HID: ${employeeData.hid}`, 14, 38);
    }

    const tableColumn = ["Type", "Date", "Reason", "Status", "Requested On", "Admin Message"];
    const tableRows = [];

    // Iterate through leaveHistory and extract valid rows
    leaveHistory?.forEach((req) => {
      req.leaveDates?.forEach((d) => {
        // You can remove this "if" if you want to include all requests, not only non-pending
        if (d.status !== "Pending") {
          tableRows.push([
            d.leaveType || "-",
            d.date || "-",
            req.reason || "-",
            d.status || "-",
            new Date(req.date).toLocaleDateString(),
            d.note || req.message || "-"
          ]);
        }
      });
    });

    if (tableRows.length === 0) {
      alert("No approved/rejected leave records to export.");
      return;
    }

    doc.autoTable({
      startY: 45,
      head: [tableColumn],
      body: tableRows,
      styles: { fontSize: 10 },
    });

    doc.save("hotel_history.pdf");
  };

  useEffect(() => {
    const fetchEmployeeByEmail = async () => {
      setLoading(true);
      try {
        const userEmail = auth.currentUser?.email;
        if (!userEmail) {
          throw new Error("No user email found.");
        }

        const employeesRef = collection(db, "employees");
        const q = query(employeesRef, where("mail", "array-contains", userEmail));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const employeeDoc = snapshot.docs[0];
          const employeeData = employeeDoc.data();
          setEmployeeData(employeeData);
          sethid(employeeData.hid); // Optional: if you're still using it

          // Load leave history
          const leaveQuery = query(
            collection(db, "leaveRequests"),
            where("hid", "==", employeeData.hid)
          );
          const leaveSnapshot = await getDocs(leaveQuery);
          const requests = leaveSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setLeaveHistory(requests);

          const sorted = requests.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
          const latest = sorted[0];

          if (latest) {
            const statuses = latest.leaveDates?.map(d => d.status) || [];

            if (statuses.length === 0) setLeaveStatus(null);
            else if (statuses.every(s => s === "Approved")) setLeaveStatus("Approved");
            else if (statuses.every(s => s === "Rejected")) setLeaveStatus("Rejected");
            else if (statuses.every(s => s === "Pending")) setLeaveStatus("Pending");
            else setLeaveStatus("Partially Approved");
          } else {
            setLeaveStatus(null);
          }

        } else {
          setEmployeeData(null);
          alert("No hotel record found for this email.");
        }
      } catch (error) {
        console.error("Error fetching employee by email:", error);
        alert("Something went wrong loading your hotel info.");
      }
      setLoading(false);
    };

    fetchEmployeeByEmail();
  }, []);

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const email = auth.currentUser?.email;
        if (!email) return;

        const usersRef = collection(db, "users");
        const q = query(usersRef, where("email", "==", email));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const userDoc = snapshot.docs[0];
          const userData = userDoc.data();
          setUserName(userData.name); // this is the personal name
        } else {
          setUserName(""); // fallback
        }
      } catch (err) {
        console.error("Failed to fetch user name:", err);
      }
    };

    fetchUserName();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
      alert("Failed to log out.");
    }
  };

  return (
    <div className="user-dashboard">
      <button onClick={handleLogout} className="log-out"> Logout </button> 
       
      <div className="welcome-section">
        {/* <div className="flex justify-end mb-4"></div> */}

        {/* ✅ FIX: Add conditional rendering to check if employeeData exists */}
        <h2 className="welcome-heading">
          <strong>Welcome To </strong>
          {employeeData ? employeeData.name : "Loading..."}
        </h2>

        {loading && <p style={{ color: "maroon" }}>Loading...</p>}

        {employeeData && (
          <div>
            <h3>Your Details</h3>
            <h4><strong>Company:</strong> {employeeData.name}</h4>

            <h3><strong>Name :</strong> {userName || auth.currentUser?.email}</h3>

            <div className="button-row">
              <button
                className="login-btn"
                onClick={() =>
                  navigate("/securityscanqr", { state: { hotelName: employeeData.name } })
                }
              >
                Scan QR
              </button>
              
              <button
                className="login-btn"
                onClick={() =>
                  navigate("/vehiclescan", { state: { hotelName: employeeData.name } })
                }
              >
                Scan Vehicle
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Securitydash;